module.exports = __webpack_public_path__ + "img/range-icon.860be230.svg";